import React from 'react'
import type { SkeletonProps } from '@material-ui/lab/Skeleton'
import MuiSkeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  rect: {
    borderRadius: theme.borderRadius.md
  },
  text: {
    borderRadius: theme.borderRadius.md
  }
}))

export type { SkeletonProps }

export default function Skeleton(props: SkeletonProps) {
  const classes = useStyles(props)

  return <MuiSkeleton variant="rect" animation="wave" {...props} classes={classes} />
}

export const StyledSkeleton: typeof Skeleton = ({ ...props }) => {
  return <Skeleton height="100px" width="100%" {...props} />
}
